import { useState } from "react";
import { FileType, ModalState } from "../types";
import { DocumentsType } from 'v2-types/order';

export const useModalManager = () => {
  const [modalState, setModalState] = useState<ModalState>({ type: 'closed' });

  const modalActions = {
    openViewModal: (fileId: string) =>
      setModalState({ type: 'view', fileId }),

    openLockToggleModal: (documentId: string, lock: boolean, documentTitle: string) =>
      setModalState({ type: 'toggleDocumentLock', documentId, lock, documentTitle }),

    openEditPdfZipBundleModal: (document: DocumentsType) =>
      setModalState({ type: 'editBundleZipPdfContent', document }),

    openDocumentModal: (document: DocumentsType, modalType: 'editExpectedFrom' | 'uploadDocumentFiles' | 'editTemplateData') => {
      setModalState({ type: modalType, document });
    },

    openFileSignatureRequestModal: (type: "requestSignature", documentId: string, fileSource: string, documentName: string) => {
      setModalState({ type, documentId, fileSource, documentName });
    },

    openDeleteFileModal: (file: FileType) =>
      setModalState({ type: 'deleteFileConfirmation', file }),

    openCreateDocumentModal: () =>
      setModalState({ type: 'createNewDocument' }),

    openDeleteDocumentModal: (document: DocumentsType) =>
      setModalState({ type: 'deleteDocumentConfirmation', document }),

    openAlertFileUploadProcessModal: () =>
      setModalState({ type: 'alertFileUploadProcess' }),

    openRequestFileUploadModal: () =>
      setModalState({ type: 'requestFileUploadModal' }),

    closeModal: () => setModalState({ type: 'closed' }),
  };

  return { modalState, modalActions: { ...modalActions } };
};